<div class="empty-station-item" *ngIf="station"
    [ngClass]="{'disabled':station.stationUsage.suspended || station.stationUsage.disabled, 'selected': selected}">
    <sc-flex [fitHeight]="true" [centered]="true" [vertical]="true">
        <div>
            <sc-flex >
                <div class="icon">
                    <sc-icon iconClass="fa-lock fa-2x" *ngIf="station.stationUsage.suspended"></sc-icon>
                    <sc-icon iconClass="fa-xmark fa-3x" *ngIf="station.stationUsage.disabled"></sc-icon>
                </div>
                <sc-content-spacer></sc-content-spacer>
                <div class="title">
                    {{station.name}}
                </div>
            </sc-flex>
        </div>
        <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
        <div *ngIf="station.stationUsage.suspended">{{station.stationUsage.note}}</div>
        <div *ngIf="station.stationUsage.loadingZoneLock">{{'alle Ladezonen gesperrt' | translate : ['tmc-yard.widgets.sac-client.transport-details-list-entry.action.create-movement-order',
            translationService.language]}}</div>
    </sc-flex>
</div>